import { memo } from "react";

/**
 * A text cell that reads as plain text at rest and edits in place — the input
 * is always live, so nothing has to be opened to change a value.
 *
 * @param {object} props
 * @param {string} props.value
 * @param {boolean} [props.dirty] changed and not yet saved
 * @param {string} [props.error] message when the value is rejected
 * @param {string} props.ariaLabel
 * @param {string} [props.placeholder]
 * @param {boolean} [props.strong] heavier weight, for a row's identifying cell
 * @param {boolean} [props.disabled]
 * @param {(value: string) => void} props.onChange
 */
function TextCell({ value, dirty, error, ariaLabel, placeholder, strong, disabled, onChange }) {
  const classes = [
    "kgb-cell",
    strong ? "kgb-cell--strong" : "",
    dirty ? "kgb-cell--dirty" : "",
    error ? "kgb-cell--invalid" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <input
      type="text"
      className={classes}
      value={value ?? ""}
      placeholder={placeholder}
      disabled={disabled}
      aria-label={ariaLabel}
      aria-invalid={error ? "true" : undefined}
      title={error || undefined}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

export default memo(TextCell);
